import { render, staticRenderFns } from "./layoutBlank.vue?vue&type=template&id=27f3cc6c&"
import script from "./layoutBlank.vue?vue&type=script&lang=js&"
export * from "./layoutBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "layoutBlank.vue"
export default component.exports